var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnPremiseLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 67,
    viewBox: "0 0 51 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8348 1.60632C23.4012 -0.176879 27.5991 -0.17688 31.1655 1.60632L50.8362 11.4417V39.6914C50.8362 49.4458 41.8194 56.0304 25.5001 66.3365C9.18089 56.0304 0.164062 47.3345 0.164062 39.6914V11.4417L19.8348 1.60632ZM31.8311 28.4229C31.8311 31.0277 30.4161 33.3019 28.3129 34.5188V46.0135C28.3129 47.9569 26.7374 49.5324 24.794 49.5324C22.8505 49.5324 21.2751 47.9569 21.2751 46.0135V34.5196C19.1711 33.3028 17.7555 31.0282 17.7555 28.4229C17.7555 24.5361 20.9065 21.3851 24.7933 21.3851C28.6802 21.3851 31.8311 24.5361 31.8311 28.4229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnPremiseLg);
export default __webpack_public_path__ + "static/media/on-premise-lg.54c3064dcc470204c64d7da06be6b321.svg";
export { ForwardRef as ReactComponent };